<template>
  <Modal v-bind="$attrs" @open="onModalOpen" @cancel="emits('cancel')" @confirm="onConfirm">
    <el-form ref="formRef" @submit.native.prevent :model="planForm" :rules="rules">
      <el-form-item prop="budget">
        <el-input v-model.trim="planForm.budget" @keyup.native.enter="onConfirm" placeholder="请输入预算"></el-input>
      </el-form-item>
    </el-form>
  </Modal>
</template>

<script setup>
import { ref, toRefs } from 'vue'
import Modal from '@/views/create/gdt/components/distribute/components/modal.vue'
import { getPlanFormRules } from '@/views/create/bytedance/rules/index.js'
// eslint-disable-next-line
const emits = defineEmits(['cancel', 'confirm'])
// eslint-disable-next-line
const props = defineProps({
  currentRow: Object
})
const { currentRow } = toRefs(props)
const formRef = ref(null)
const rules = ref({})
const planForm = ref({ budget: '' })

function onModalOpen() {
  planForm.value = currentRow.value.creative_params
  rules.value = getPlanFormRules.call({ planForm: planForm.value, projectForm: currentRow.value.outer_plan_params })
}
function onConfirm() {
  formRef.value.validate((valid) => {
    if (valid) {
      const value = Number(planForm.value.budget)
      emits('confirm', value)
    }
  })
}
</script>

<style lang="scss" scoped>
</style>
